import { Injectable, inject } from '@angular/core';
import { UtilityService } from '@core/services/utility.service';
import { SmDataService } from './sm-data.service';
import { SmOfflineService } from './sm-offline.service';
import { SmService } from './sm.service';
import { CompleteTripModalComponent } from 'src/app/modals/sm/complete-trip-modal/complete-trip-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TimeoutService } from 'src/app/core/services/timeout.service';
import { Router } from '@angular/router';
import { EventService } from '@core/services/event.service';
import moment from 'moment';
import { SessionStorageService } from '@core/services/session-storage.service';
import { SmSessionKeys } from '../constants/session-keys.constant';

@Injectable({
  providedIn: 'root',
})
export class SmSharedService {
  private readonly smService = inject(SmService);
  public readonly smDataService = inject(SmDataService);
  private readonly utilityService = inject(UtilityService);
  private readonly ngbModalService = inject(NgbModal);
  private readonly timeoutService = inject(TimeoutService);
  private readonly router = inject(Router);
  private readonly eventService = inject(EventService);
  private readonly smOfflineService = inject(SmOfflineService);
  private readonly sessionStorageService = inject(SessionStorageService);

  public format = this.utilityService.getDateFormat();

  public getClockInStatus(): void {
    this.smService.getClockInStatus().then((response: any) => {
      if (response != null) {
        this.smDataService.clockInStatus = response;
        if (this.smDataService.clockInStatus.ClockTime != null) {
          this.smDataService.clockInStatus.ClockTimeDisplay = moment(this.smDataService.clockInStatus.ClockTime).utc().format('LT');
          this.smDataService.clockInStatus.ClockDateDisplay = moment(this.smDataService.clockInStatus.ClockTime).utc().format('YYYY-MM-DD');
        }
      } else {
        this.smDataService.clockInStatus = null;
      }
      this.utilityService.closeModal();
      this.eventService.broadcast('navClockStatus', this.smDataService.clockInStatus);

      this.smDataService.clockEmpty = false;

      if (this.smDataService.clockInStatus == null) this.smDataService.clockEmpty = true;
    });
  }

  public getSignature(): void {
    this.smDataService.signatures = [];
    let scopesString = '';
    $.each(this.smDataService.tempClose, function (key, val) {
      scopesString += val.SMWorkOrderScopeID + ',';
    });

    this.smService.getSignatures(this.smDataService.currentWorkOrder.SMTripID, scopesString).then((response: any) => {
      this.smDataService.signatures = response;
      this.smDataService.signatures.forEach((val, key) => {
        val.SignatureImage = 'data:image/png;base64,' + val.SignatureImage;
        val.dateSignedString = moment(val.SignDate).format('MM/DD/YYYY');
      });

      this.router.navigate(['/sm/closeout']);
    });
  }

  public scopeDataCalculate(data): void {
    if (data.ScopeData != null) {
      let BillableHours = 0.0,
        HasBilledMatlCount = 0,
        HasPOCount = 0,
        LaborHours = 0.0,
        TotalItems = 0,
        Units = 0.0,
        BudgetLaborHours = 0;
      data.ScopeData.forEach((val, key) => {
        val.IsLumpSum = val.IsLumpSum == '0' ? false : true;
        if (!val.IsLumpSum) BillableHours += parseFloat(val.SummaryBillableHours);
        LaborHours += parseFloat(val.SummaryLaborHours);
        Units += parseFloat(val.SummaryUnits);
        TotalItems += parseInt(val.SummaryTotalItems);
        HasBilledMatlCount =
          parseInt(val.MaterialItemCount) > 0 ? (HasBilledMatlCount += parseInt(val.MaterialItemCount)) : HasBilledMatlCount;
        HasPOCount = parseInt(val.POLineCount) > 0 ? (HasPOCount += parseInt(val.POLineCount)) : HasPOCount;
        BudgetLaborHours += val.BudgetLaborHours != null ? parseFloat(val.BudgetLaborHours) : 0;
      });

      data.SummaryBillableHours = BillableHours;
      data.SummaryHasBilledMatl = HasBilledMatlCount > 0 ? true : false;
      data.SummaryHasPO = HasPOCount > 0 ? true : false;
      data.SummaryLaborHours = LaborHours;
      data.SummaryTotalItems = TotalItems;
      data.SummaryUnits = Units;
      data.BudgetLaborHours = BudgetLaborHours;
    }
  }

  public modifyNewRow(data): void {
    if (data != null) {
      if (data.ScheduledDate != null) {
        data.date = moment(data.ScheduledDate).utc().format('YYYY/MM/DD');
        data.ScheduledDateDisplay = moment(data.ScheduledDate).utc().format('DD/MMM');
      }
      if (data.ScheduledEndDate != null) {
        data.ScheduledEndDateDisplay = moment(data.ScheduledEndDate).utc().format('DD/MMM');
      }
      if (data.TripDetails != null && data.TripDetails != '') {
        data.TripDetailsHtml = data.TripDetails;
      }
      if (data.TripNotes != null && data.TripNotes != '') {
        data.TripNotesHTML = data.TripNotes;
      } else {
        data.TripNotesHTML = null;
      }

      this.scopeDataCalculate(data);

      if (data.PriorityColor != null) {
        const tempColor = this.utilityService.hexToRgb(data.PriorityColor);
        if (tempColor.r * 0.299 + tempColor.g * 0.587 + tempColor.b * 0.114 > 186) data.fontColor = '#363545';
        else data.fontColor = '#ffffff';
      } else {
        data.PriorityColor = '#C81922';
        data.fontColor = '#363545';
      }
      data.TripName =
        (data.ScheduledDate != null ? data.ScheduledDateDisplay + ' -' : '') +
        (data.ScheduledEndDate != null ? data.ScheduledEndDateDisplay + ' -' : '') +
        (data.ScheduledTime != null ? data.ScheduledTime + (data.SMTripID != -2 ? ' -' : '') : '') +
        (data.SMTripID != -2 ? 'WO #' + data.WorkOrder : '');
      data.FullAddress = [data.Address1, data.Address2, data.City, data.State, data.Zip].filter(Boolean).join(' ');
    }
  }

  public getScopePurchaseOrders(data, closeOut, index): void {
    const url =
      '?sMWorkOrderScopeID=' + (data == null ? this.smDataService.currentWorkOrderScopeData.SMWorkOrderScopeID : data.SMWorkOrderScopeID);
    this.smService.getScopePurchaseOrders(url).then((response: any) => {
      if (this.smDataService.completedList == null) {
        if (closeOut) {
          this.smDataService.completedList = { Equipment: [], Labor: [], Misc: [], Inventory: [], PO: [] };
        } else {
          this.smDataService.completedList = {};
        }
      }
      let totalAmount = 0;
      let taxCharge = 0;
      this.smDataService.completedList['PO'] = [];
      response.forEach((val, key) => {
        if (val.PODate != null) {
          val.PODateDisplay = moment(val.PODate).utc().format(this.format.substr(0, 8).toUpperCase());
        }
        totalAmount += val.PriceTotal;
        taxCharge += val.TaxAmount;
        this.smDataService.completedList['PO'].push(val);
      });

      if (closeOut) {
        if (this.smDataService.closeDetailsList[index].IsLumpSum) {
          totalAmount = this.smDataService.closeDetailsList[index].LumpSumAmt;
          taxCharge = this.smDataService.closeDetailsList[index].TotalWOTaxAmount;
          this.smDataService.totalTripCharge = totalAmount;
          this.smDataService.totalTaxCharge = taxCharge;
        } else {
          this.smDataService.totalTripCharge += totalAmount;
          this.smDataService.totalTaxCharge += taxCharge;
        }
        this.smDataService.closeDetailsList[index]['completedList'] = JSON.parse(JSON.stringify(this.smDataService.completedList));
        if (isNaN(this.smDataService.closeDetailsList[index]['totalAmount'])) {
          this.smDataService.closeDetailsList[index]['totalAmount'] = 0;
        }
        this.smDataService.closeDetailsList[index]['totalAmount'] = totalAmount;
      }
    });
  }

  public getSignerContacts(): void {
    this.smService.getSignerContacts(this.smDataService.currentWorkOrder.SMWorkOrderID, this.smDataService.currentWorkOrder.SMTripID).then(
      (response: any) => {
        this.smDataService.signDisList = {};
        this.smDataService.signOffList = [];
        this.smDataService.signOffListRaw = [];
        this.smDataService.emailCCList = [];

        response.forEach((val, key) => {
          val.Display = val.FirstName + ' ' + val.LastName + (val.Organization != null ? ' - ' + val.Organization : '');
          if (val.AlwaysEmail) {
            this.smDataService.emailCCList.push(val);
          }
          this.smDataService.signOffList.push(val);
          this.smDataService.signOffListRaw.push(val);
        });
        if (this.smDataService.currentScopeSettings != null && this.smDataService.currentScopeSettings.WorkCompletedCCEmailList != null) {
          this.smDataService.currentScopeSettings.WorkCompletedCCEmailList.split(',').forEach((val, key) => {
            this.smDataService.emailCCList.push({ Email: val.trim() });
          });
        }
        this.smDataService.signOffList.push({
          Email: '',
          FirstName: '',
          LastName: '',
          Organization: '',
          Title: '',
          Display: 'Add a new contact...',
          HQContactID: -1,
        });
        this.smDataService.signOffList.unshift({
          Email: '',
          FirstName: '',
          LastName: '',
          Organization: '',
          Title: '',
          Display: 'No Signer',
          HQContactID: -2,
        });
      },
      error => {}
    );
  }

  public resetPage(loadTrip, clockOut, routeToManage): void {
    if (routeToManage) this.router.navigate(['/sm/manage']);
    this.smDataService.allShow = true;
    this.smDataService.lookupList = {};
    this.smDataService.currentWorkOrder = null;
    this.smDataService.currentWorkOrderScopeData = null;
    this.smDataService.currentScopeSettings = null;
    this.smDataService.scopeNoData = false;
    this.smDataService.isCloseOut = false;
    this.smDataService.completedList = {};
    this.smDataService.serviceDetailsFromGrid = false;
    this.smDataService.serviceDetailsFromDetails = false;
    this.smDataService.isCollectSignature = false;
    this.smDataService.collectPayment = false;
    this.smDataService.isDrillDown = false;
    this.smDataService.isClockOut = false;
    if (loadTrip) {
      this.smDataService.tripList = null;
      this.smDataService.tripListFiltered = null;
      this.eventService.broadcast('smGetTrip');
    }
    if (clockOut) {
      this.eventService.broadcast('smClockOutAction');
    }
  }

  public removeSession(): void {
    [
      SmSessionKeys.CURRENT_WORK_ORDER,
      SmSessionKeys.CURRENT_SCOPE,
      SmSessionKeys.LAST_SCROLL,
      SmSessionKeys.FROM_DATE,
      SmSessionKeys.TO_DATE,
      SmSessionKeys.IS_DRILL_DOWN,
      SmSessionKeys.UNSCHEDULED,
      SmSessionKeys.SORT_VALUE,
      SmSessionKeys.SEARCH_TEXT,
      SmSessionKeys.STAY_SERVICE_DETAILS,
      SmSessionKeys.DASH_TO_MANAGE_ID,
      SmSessionKeys.DASH_TO_MANAGE_TRIP,
    ].forEach(key => this.sessionStorageService.removeItem(key));
  }

  public async completeTrip(isCollectSignature): Promise<any> {
    const modalRef = this.ngbModalService.open(CompleteTripModalComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.currentTrip = this.smDataService.currentWorkOrder;
    modalRef.componentInstance.lookup = this.smDataService.lookupList;
    modalRef.componentInstance.clockStatus = this.smDataService.clockInStatus;
    modalRef.componentInstance.isCollectSignature = isCollectSignature;
    modalRef.result.then(result => {
      /*
          $scope.closeDetailsList = []; scopeData, tasksList, idList, selectedTasksList, selectedTaskItem, completedList, savedFiles, templateList
      */

      if (!result.justComplete) {
        this.timeoutService.refreshTimeout();
        this.utilityService.openModal();
        this.smDataService.isCloseOut = true;
        this.smDataService.tempClose = [];
        this.smDataService.closeDetailsList = [];
        this.smDataService.signList = [];
        this.smDataService.signCount = 0;
        this.smDataService.closeOutTotalList = [];
        this.smDataService.isCollectSignature = isCollectSignature;
        this.smDataService.revisitRequired = result.revisitRequired;
        this.smDataService.revisitReason = result.revisitReason;
        this.smDataService.revisitNotes = result.revisitNotes;
        this.smDataService.loadAttachData = result.loadAttachData;
        this.smDataService.collectPayment = result.collectPayment;
        this.smDataService.bypassAttach = result.bypassAttach;
        this.smDataService.tempCloseExcludeForInvoice = result.tempCloseExcludeForInvoice;

        result.closeList.forEach((val, key) => {
          if (val.IsClose) {
            this.smDataService.tempClose.push(val);
            this.smDataService.closeDetailsList.push({});
          }
        });
        this.smDataService.totalTripCharge = 0;
        this.smDataService.totalTaxCharge = 0;
        this.smDataService.taskShowComplete = true;
        if (this.smDataService.currentWorkOrder.TripNotes != null && this.smDataService.currentWorkOrder.TripNotes != '')
          this.smDataService.currentWorkOrder.TripNotesHTML = this.smDataService.currentWorkOrder.TripNotes;
        else {
          this.smDataService.currentWorkOrder.TripNotesHTML = null;
        }

        this.smService.getSettingsBySMCo(this.smDataService.tempClose[0].SMCo).then((response: any) => {
          this.smDataService.currentScopeSettings = response[0];
          if (this.smDataService.currentOnline) this.getSignature();
          else this.router.navigate(['/sm/closeout']);
        });
      } else {
        this.resetPage(true, false, true);
        return result.success;
      }
    });
  }

  public updateServiceItemExistsList(): void {
    this.smDataService.updatedSIList = [];

    if (this.smDataService?.lookupList['SMServiceableItem']?.length > 0) {
      const tempSIList = this.smDataService.lookupList['SMServiceableItem'].slice();
      const updatedArrayA = tempSIList.map(itemA => {
        let existsInB = false;
        const woIDInB = [];

        if (this.smDataService.woUsedSIList.length > 0) {
          this.smDataService.woUsedSIList.some(itemB => {
            if (itemB.ServiceItem === itemA.Code) {
              existsInB = true;
              woIDInB.push(itemB.SMWorkCompletedID);
            }
          });
        }
        return { ...itemA, exists: existsInB, woID: woIDInB };
      });

      this.smDataService.updatedSIList = updatedArrayA;
    }
  }

  public async manageTripNoteUpdate(timeStampFromModal, data, newNote): Promise<any> {
    let tripNote = null;
    if (timeStampFromModal) {
      tripNote = newNote;
    } else {
      if (this.smDataService.currentScopeSettings?.TripNotesVisibilty == 'Date') {
        tripNote = null;
      } else {
        tripNote = data.TripNotes;
      }
    }
    if (this.smDataService.enablePWA) {
      if (!this.smDataService.currentOnline && navigator.serviceWorker.controller != null)
        navigator.serviceWorker.controller.postMessage({
          shouldOfflineSync: false,
          sMTripID: data.SMTripID,
          tripNotes: tripNote,
          workOrderDescription: data.WorkOrderDescription,
          tripDescription: data.TripDescription,
          installDatabase: false,
          storeOfflineSyncTrip: false,
        });
    }
    await this.smService.updateTripNotes(data.SMTripID, tripNote, data.WorkOrderDescription, data.TripDescription).then(
      (response: any) => {
        if (response.success) {
          this.smDataService.tempOldTripNotes = null;
          data.TripNotes = response.data;
          data.TripNotesHTML = data.TripNotes;
        }
        if (!response.success && this.smDataService.tempOldTripNotes != null) data.TripNotes = this.smDataService.tempOldTripNotes;
        this.smDataService.saveResult = response;
        return response;
      },
      error => {
        if (!this.smDataService.currentOnline) {
          this.smDataService.tempOldTripNotes = null;
          this.smOfflineService.updateTripNotes(data.SMTripID, data.TripNotes, data.WorkOrderDescription, data.TripDescription);
        }
      }
    );
  }
}
